import ReactEcharts from 'echarts-for-react';
import { isAdmin } from 'utils/isAdmin';

const WIDTH = 25;
const GaugeChart = ({
  value = 50,
  name = 'DSI',
  height = 200,
  width = 200,
}) => {
  const isAdminRoute = isAdmin() ? '#000' : '#fefefe';

  const options = {
    tooltip: {
      formatter: '{a} <br/>{b}: {c}',
    },
    title: {
      text: name, // Tiêu đề biểu đồ
      left: 'center',
      top: '90%',
      textStyle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: isAdminRoute,
      },
    },
    series: [
      {
        progress: {
          show: true,
          width: WIDTH,
          color: ['#e0e0e0'],
        },
        name: 'Speed',
        type: 'gauge',
        radius: '100%',
        startAngle: 225,
        endAngle: -45,
        min: 0,
        max: value * 2,
        splitNumber: 9,
        axisLine: {
          lineStyle: {
            width: WIDTH,
            color: [[1, '#e0e0e0']],
          },
        },
        pointer: {
          width: 5,
          length: '40%',
          color: '#37a2da',
        },

        axisTick: {
          show: false, // Remove tick marks
        },
        splitLine: {
          show: false, // Remove split lines
        },
        axisLabel: {
          show: false, // Remove numbers around the gauge
        },
        detail: {
          show: true, // Remove the central value display
          valueAnimation: true,
          color: isAdminRoute,
        },
        data: [
          {
            value: value, // Current speed value (hidden now)
          },
        ],
      },
    ],
  };
  return (
    <div className="gauge-chart">
      <ReactEcharts
        option={options}
        style={{ width: width, height: height }}
        onEvents={() => {}}
      ></ReactEcharts>
    </div>
  );
};

export default GaugeChart;
